import { render } from "./C_Ctp_title.vue?vue&type=template&id=02dc88c5&scoped=true&ts=true"
import script from "./C_Ctp_title.vue?vue&type=script&lang=ts"
export * from "./C_Ctp_title.vue?vue&type=script&lang=ts"

import "./C_Ctp_title.vue?vue&type=style&index=0&id=02dc88c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dc88c5"]])

export default __exports__